module.exports = __webpack_public_path__ + "static/media/IMG-20181215-WA0010.c4d25e2e.jpg";